import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
/* Layout */
import Layout from '@/layout'
/* Router Modules*/
// import componentsRouter from './modules/components'
// import chartsRouter from './modules/charts'
// import tableRouter from './modules/table'
// import nestedRouter from './modules/nested'
/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
// 静态的路由页面
export const constantRoutes = [{
  path: '/redirect',
  component: Layout,
  hidden: true,
  children: [{
    path: '/redirect/:path(.*)',
    component: () => import('@/views/redirect/index')
  }]
},
{
  path: '/login', // 首页 登录页面
  component: () => import('@/views/login/index'),
  hidden: true
},
{
  path: '/binding', // 首页 换绑定
  component: () => import('@/views/login/binding'),
  hidden: true
},
{
  path: '/bindingYZ', // 首页 微信相关
  component: () => import('@/views/login/bindingYZ'),
  hidden: true
},
{
  path: '/privacy', // 首页 隐私政策
  component: () => import('@/views/login/privacy'),
  hidden: true
},
{
  path: '/auth-redirect', // 登录的副页面
  component: () => import('@/views/login/auth-redirect'),
  hidden: true
},
{
  path: '/404',
  component: () => import('@/views/error-page/404'),
  hidden: true
},
{
  path: '/registers',
  component: () => import('@/views/login/registers'),
  hidden: true
},
{
  path: '/401',
  component: () => import('@/views/error-page/401'),
  hidden: true
},
{
  path: '/map3d',
  component: () => import('@/views/Map3D/map3d'),
  hidden: true
},
{
  path: '/patrolPointRecord',
  component: () => import('@/views/separatePage/patrolPointRecord'),
  hidden: true
},
{
  // "sortno": "2",
  // "path": "/datav",
  // "component": "dataV_ltxa/index",
 
  // "name": "datav",
  // "menuid": "31cd4aae-51d1-485e-bab7-a59b4e2e8608",
  // "menuparentid": "111"

  path: '/newDatav',
  component: () => import('@/views/dataV_new/index'),
  hidden: true,
  "meta": {
    "icon": "dashboard",
    "title": "数据大屏"
},
}
  // {
  //   path: '/skyMapDisplay',
  //   component: () => import('@/views/skyMapDisplay'),
  //   hidden: true
  // },
  // {
  //   path: '/efficiency',
  //   component: () => import('@/views/overviewInformation/efficiency'),
  //   hidden: true
  // },
  // {
  //   path: '/wantToEdit',
  //   component: () => import('@/views/overviewInformation/wantToEdit'),
  //   hidden: true
  // }
  // {
  //   path: '/skyMapDisplay',
  //   component: Layout,
  //   hidden: true,
  //   // redirect: '/monitor',
  //   children: [
  //  {
  //   component: () => import('@/views/skyMapDisplay'),

  //   hidden: true,
  //   // redirect: '/skyMapDisplay',
  //  }
  //   ]
  // }

  // {
  //   'path': 'overviewInformation/overviewInformation',
  //   'name': '推演数据'
  // },
  // {
  //   'path': 'overviewInformation/efficiency',
  //   'name': '复盘分析'
  // },

// efficiency
]

// export const asyncRoutes = []

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRoutes
})
// router.selfaddRoutes = function (params){
//   router.matcher = new Router().matcher;
//   router.addRoutes(params)
// }
const router = createRouter()
// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
